import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';

import * as UserStore from '../../../app/store/UserStore';
import { VimoMenu } from '../../../common/components';
import urls from '../../../app/urls';


class UserMenu extends React.Component {
    deleteUser = (callback) => {
        this.props.deleteElement(this.props.userData, { callback, errorCallback: callback, redirect: urls.inside.users.home });
    }

    generateNewPassword = (callback) => {
        const saveData = {
            ...this.props.userData,
            generateNewPassword: true,
        };

        this.props.updateElement(saveData, { callback, errorCallback: callback });
    }

    render() {
        const {
            translate, clientConfig, className, startEditDetails,
        } = this.props;

        return (
            <VimoMenu
                className={className}
                menuItems={[
                    {
                        header: translate('user.editDetails'),
                        clickAction: startEditDetails,
                    },
                    {
                        header: translate('user.generateNewPassword'),
                        description: translate('user.generateNewPasswordDescription'),
                        action: this.generateNewPassword,
                        hidden: clientConfig.u_FnrLogin,
                    },
                    {
                        header: translate('user.delete'),
                        description: translate('user.deleteDescription'),
                        action: this.deleteUser,
                        actionText: translate('user.confirmDelete'),
                        danger: true,
                    },
                ]}
            />
        );
    }
}

UserMenu.propTypes = {
    translate: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    deleteElement: PropTypes.func.isRequired,
    updateElement: PropTypes.func.isRequired,
    startEditDetails: PropTypes.func.isRequired,
    className: PropTypes.string,
};

UserMenu.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(UserStore.actionCreators, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
